import { generateOperationId } from "./operation.js";
/**
 * @see {@link RemoveEntityOperation}
 */
export const RemoveEntityOperationType = "http://dataspecer.com/core/operation/remove-entity";
export function createRemoveEntityOperation(entityId) {
    return {
        id: generateOperationId(),
        type: RemoveEntityOperationType,
        entityId,
    };
}
export function isRemoveEntityOperation(operation) {
    return operation.type === RemoveEntityOperationType;
}
/**
 * @see {@link SetEntityOperation}
 */
export const SetEntityOperationType = "http://dataspecer.com/core/operation/set-entity";
export function createSetEntityOperation(entity) {
    return {
        id: generateOperationId(),
        type: SetEntityOperationType,
        entity,
    };
}
export function isSetEntityOperation(operation) {
    return operation.type === SetEntityOperationType;
}
/**
 * @see {@link UpdateEntityOperation}
 */
export const UpdateEntityOperationType = "http://dataspecer.com/core/operation/update-entity";
export function createUpdateEntityOperation(update) {
    if (!(typeof update === "object" &&
        update !== null &&
        "id" in update &&
        typeof update.id === "string" &&
        update.id.length > 0 &&
        ("type" in update ? (Array.isArray(update.type) &&
            update.type.every((t) => typeof t === "string")) : true))) {
        throw new Error("Invalid update entity.");
    }
    return {
        id: generateOperationId(),
        type: UpdateEntityOperationType,
        update,
    };
}
export function isUpdateEntityOperation(operation) {
    return operation.type === UpdateEntityOperationType;
}
//# sourceMappingURL=entity-operations.js.map